<template>
  <div>
    <div class="col-12 px-0">
      <h1 class="d-flex align-items-center">
        <span class="icon mr-2 icon-editieren" aria-hidden="true"></span>
        {{ $t('views.timeSlotEditMultiCapacity.title') }}
      </h1>
    </div>

    <button-back @clicked="back()" />

    <loading-container :state="state">
      <form @submit.prevent="onSubmit()" class="mt-2">

        <div class="row mx-auto">
          <div class="col-12 col-md-4 d-flex bg-lightblue p-3 kapazitaetrow multi">

          <control-date
            i18nLabel="views.timeSlotEditMultiCapacity.from"
            :validation="v$.startDate"
            v-model="startDate"
            class="d-flex flex-wrap align-items-center mr-3"
          />

          </div>
          <div class="col-12 col-md-4 d-flex bg-lightblue p-3 kapazitaetrow multi">

            <control-date
              i18nLabel="views.timeSlotEditMultiCapacity.until"
              :validation="v$.endDate"
              v-model="endDate"
              class="d-flex flex-wrap align-items-center mr-3"
            />

          </div>
          <div class="col-12 col-md-4 d-flex bg-lightblue p-3 kapazitaetrow multi">

            <control-integer
              i18nLabel="common.timeSlot.capacity"
              :validation="v$.capacity"
              v-model="capacity"
              class="d-flex flex-wrap align-items-center mr-3"
            />

          </div>
        </div>

        <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 mt-4 px-xs-0">
          <button-save i18nMessage="views.timeSlotEditMultiCapacity.save" class="btn-w-100" />
        </div>
      </form>
    </loading-container>
  </div>
</template>

<script lang="ts">
import ControlDate from '@/components/controls/ControlDate.vue';
import ControlInteger from '@/components/controls/ControlInteger.vue';
import ButtonBack from '@/components/interaction/ButtonBack.vue';
import ButtonSave from '@/components/interaction/ButtonSave.vue';
import LoadingContainer from '@/components/structure/LoadingContainer.vue';
import { Room, TimeSlotCapacityUpdate } from '@/generated/openapi';
import LoadingMixin from '@/mixins/LoadingMixin';
import { InfoPopupBase, InfoPopupType } from '@/models/InfoPopupData';
import { adminService } from '@/services/adminService';
import { formatDateString } from '@/utils/formatUtils';
import { validateAndFocusInvalid } from '@/utils/formUtils';
import { LoadingState } from '@/utils/loadingUtils';
import { smartBack, urlParamString } from '@/utils/navigationUtils';
import { isAfterStartDate, isDateString, requiredInteger } from '@/utils/validationUtils';
import useVuelidate from '@vuelidate/core';
import { between, required } from '@vuelidate/validators';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TimeSlotEditMultiCapacity',
  mixins: [
    LoadingMixin
  ],
  components: {
    LoadingContainer,
    ControlInteger,
    ButtonSave,
    ButtonBack,
    ControlDate
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  data() {
    return {
      roomId: '',
      room: {} as Room,
      startDate: '',
      endDate: '',
      capacity: 0,
    }
  },
  validations() {
    return {
      startDate: {
        required,
        isDateString
      },
      endDate: {
        isAfterStartDate
      },
      capacity: {
        requiredInteger,
        between: between(0, 99999)
      }
    }
  },
  created() {
    this.roomId = urlParamString(this.$route, 'roomId')
    adminService.getRoom(this.roomId)
      .then(room => {
        this.room = room
        this.capacity = room.capacity || 0
        this.state = LoadingState.success
      }).catch(this.handleErrorWithI18nString)
  },
  methods: {
    onSubmit() {
      validateAndFocusInvalid(this.v$, this.$el).then(this.updateMultiCapacity)
    },
    back() {
      smartBack(this.$router, {
        name: 'admin-time-slots',
        params: { id: this.room.id }
      })
    },
    asTimeSlotCapacityUpdate(): TimeSlotCapacityUpdate {
      return {
        fromDate: this.startDate,
        untilDate: this.endDate,
        capacity: this.capacity
      }
    },
    updateMultiCapacity() {
      adminService.updateMultiCapacity(this.roomId, this.asTimeSlotCapacityUpdate())
        .then(() => {
        this.$store.commit('addInfoPopup', {
          title: this.$tc('views.timeSlotEditMultiCapacity.confirmation', {
            from: formatDateString(this.startDate),
            until: formatDateString(this.endDate),
            roomName: this.room.name,
            capacity: this.capacity,
          }),
          type: InfoPopupType.info
        } as InfoPopupBase)
          this.back()
        }).catch(this.handleErrorWithI18nString)
    }
  }
});
</script>
